import { cn as e } from "../../cn.js";
import { getStyles as t } from "./style.js";
import { CheckIcon as n, XIcon as r } from "lucide-react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { Editable as o } from "@ark-ui/react/editable";
var s = Object.assign(({ label: s, showControls: c = !0, config: l, className: u, disabled: d, ...f }) => {
	let p = t({ ...l });
	return /* @__PURE__ */ a(o.Root, {
		className: e(p.root({ disabled: d }), u),
		disabled: d,
		...f,
		children: [s && /* @__PURE__ */ i(o.Label, {
			className: p.label(),
			children: s
		}), /* @__PURE__ */ a(o.Area, {
			className: p.area(),
			children: [
				/* @__PURE__ */ i(o.Input, { className: p.input(c) }),
				/* @__PURE__ */ i(o.Preview, { className: p.preview() }),
				c && /* @__PURE__ */ i(o.Context, { children: (e) => e.editing && /* @__PURE__ */ a(o.Control, {
					className: p.control(),
					children: [/* @__PURE__ */ i(o.SubmitTrigger, {
						className: p.submitTrigger(),
						children: /* @__PURE__ */ i(n, { size: l?.size === "lg" ? 18 : l?.size === "md" ? 16 : 14 })
					}), /* @__PURE__ */ i(o.CancelTrigger, {
						className: p.cancelTrigger(),
						children: /* @__PURE__ */ i(r, { size: l?.size === "lg" ? 18 : l?.size === "md" ? 16 : 14 })
					})]
				}) })
			]
		})]
	});
}, {
	Root: ({ children: n, className: r, ...a }) => {
		let s = t();
		return /* @__PURE__ */ i(o.Root, {
			className: e(s.root({ disabled: a.disabled }), r),
			...a,
			children: n
		});
	},
	Label: ({ children: n, className: r, ...a }) => {
		let s = t();
		return /* @__PURE__ */ i(o.Label, {
			className: e(s.label(), r),
			...a,
			children: n
		});
	},
	Area: ({ children: n, className: r, ...a }) => {
		let s = t();
		return /* @__PURE__ */ i(o.Area, {
			className: e(s.area(), r),
			...a,
			children: n
		});
	},
	Input: ({ className: n, config: r, hasControls: a, ...s }) => {
		let c = t(r);
		return /* @__PURE__ */ i(o.Input, {
			className: e(c.input(a), n),
			...s
		});
	},
	Preview: ({ children: n, className: r, config: a, ...s }) => {
		let c = t(a);
		return /* @__PURE__ */ i(o.Preview, {
			className: e(c.preview(), r),
			...s,
			children: n
		});
	},
	Control: ({ children: n, className: r, ...a }) => {
		let s = t();
		return /* @__PURE__ */ i(o.Control, {
			className: e(s.control(), r),
			...a,
			children: n
		});
	},
	SubmitTrigger: ({ children: r, className: a, config: s, ...c }) => {
		let l = t(s);
		return /* @__PURE__ */ i(o.SubmitTrigger, {
			className: e(l.submitTrigger(), a),
			...c,
			children: r ?? /* @__PURE__ */ i(n, { size: s?.size === "lg" ? 18 : s?.size === "md" ? 16 : 14 })
		});
	},
	CancelTrigger: ({ children: n, className: a, config: s, ...c }) => {
		let l = t(s);
		return /* @__PURE__ */ i(o.CancelTrigger, {
			className: e(l.cancelTrigger(), a),
			...c,
			children: n ?? /* @__PURE__ */ i(r, { size: s?.size === "lg" ? 18 : s?.size === "md" ? 16 : 14 })
		});
	},
	EditTrigger: ({ children: n, className: r, config: a, ...s }) => {
		let c = t(a);
		return /* @__PURE__ */ i(o.EditTrigger, {
			className: e(c.editTrigger(), r),
			...s,
			children: n ?? "Edit"
		});
	},
	Context: o.Context,
	getStyles: t
});
export { s as EditableInput };

//# sourceMappingURL=index.js.map